import Feature from 'ol/Feature.js';
import Point from "ol/geom/Point";
import GeoJSON from "ol/format/GeoJSON.js";
import { Circle as CircleStyle, Icon, Fill, Stroke, Style} from 'ol/style.js';
import Polygon from 'ol/geom/Polygon';
import VectorLayer from 'ol/layer/Vector';
import {Vector as VectorSource} from 'ol/source';
import TileLayer from 'ol/layer/Tile';
import XYZ from 'ol/source/XYZ';
import parse from 'html-react-parser';
import DataService from '../services/getData'
import Overlay from 'ol/Overlay.js';

const total = 20; // Steps
const startColor = hexToRgb("#C30000"); // Red
const middleColor = hexToRgb("#FFEB00"); // Yellow
const endColor = hexToRgb("#5DD015"); // Green

const ColorScale = () => {
	// 2 color scheme
	//let htmlStr = "<div class='color-scale' style='background: linear-gradient(0deg, "+ ColorRange[0] + " 0%, "+ 
	//	ColorRange[total-1] +" 100%)'></div>";

	// 3 color Scheme
	let htmlStr = "<div class='color-scale' style='background: linear-gradient(0deg, "+ 
	ColorRange[0] + " 4%, "+ ColorRange[9] +" 50%, " + ColorRange[total-1] +" 94%)'></div>";

	//ColorLevel().map((color, index) => {		
		/*htmlStr += "<span style='background-color:"+color+"'>"
		if (index == 0) htmlStr += "<span class='first-score'>Min score</span>";
		if (index == ColorLevel().length-1) htmlStr += "<span class='last-score'>Max score</span>";
		htmlStr += "</span>";*/
		//console.log("Color ", index + " = ", color);
	//})
	//htmlStr += "</div>";
	//console.log("HtmlStr=", htmlStr);s
	return parse(htmlStr);
}

/*
const ColorLevel = (alpha = 1) => {
	// Styles & Colors
	/*const colors = [
	"rgba(238, 255, 230, 1)", 
	"rgba(192, 245, 168, 1)", 
	"rgba(168, 223, 143, 1)", 
	"rgba(143, 204, 116, 1)", 
	"rgba(106, 168, 79, 1)", 
	"rgba(83, 136, 60, 1)", 
	"rgba(57, 106, 36, 1)", 
	"rgba(30, 74, 11, 1)",
	"rgba(15, 51, 0, 1)", 
	"rgba(1, 3, 0, 1)"
	];

	// Two color schema
	//const startColor = {r:232, g:248, b:231};
	//const endColor  = {r:3, g:194, b:64};
    //const delta_R1 = startColor.r - endColor.r
    //const delta_G1 = startColor.g - endColor.g 
    //const delta_B1 = startColor.b - endColor.b
	//const step_R1 = delta_R1 / (total)		
	//const step_G1 = delta_G1 / (total)
	//const step_B1 = delta_B1 / (total)

	// Three color scheme
	const startColor =  {r:200, g:2, b:2}; // {r:253, g:231, b:36}; yellow
	const midColor  = {r:235, g:232, b:52};     // rgb(121,209,81)
	const endColor  = {r:3, g:194, b:64};      //rgb(0 18 153)

	const delta_R1 = midColor.r - startColor.r
	const delta_G1 = midColor.g - startColor.g
	const delta_B1 = midColor.b - startColor.b
	const delta_R2 = midColor.r - endColor.r
	const delta_G2 = midColor.g - endColor.g
	const delta_B2 = endColor.b - midColor.b

	const step_R1 = delta_R1 / (total)
	const step_G1 = delta_G1 / (total)
	const step_B1 = delta_B1 / (total)
	const step_R2 = delta_R2 / 10
	const step_G2 = delta_G2 / 10
	const step_B2 = delta_B2 / 10

	let R = startColor.r
	let G = startColor.g
	let B = startColor.b
	const gradient_colors = []
	gradient_colors.push("rgba("+ R +","+ G+","+ B+","+alpha+")");

	let i;
	for (i=1; i<total ; i++) {
			if (i > 0 && i < 10) {
					R += step_R1
					G += step_G1
					B += step_B1
			} else if (i === 10) {
					R = midColor.r 
					G = midColor.g 
					B = midColor.b
			} else if (i === 19) {
					R = endColor.r;
					G = endColor.g;
					B = endColor.b;
			} else {     
					R += step_R2;
					G += step_G2;
					B += step_B2;
			}
			R -= step_R1
			G -= step_G1
			B -= step_B1			
			gradient_colors.push("rgba("+ R +","+ G+","+ B+","+alpha+")");
	}

	R = endColor.r;
	G = endColor.g;
	B = endColor.b;
	gradient_colors.push("rgba("+ R +","+ G+","+ B+","+alpha+")");
	//console.log("Gradiend_colorw=", gradient_colors);	
	return gradient_colors;
}

const ColorRange = ColorLevel(1);
*/

// Gradient 3 colors new approach
function hexToRgb(hex) {
    // Expand shorthand form (e.g. "03F") to full form (e.g. "0033FF")
    let shorthandRegex = /^#?([a-f\d])([a-f\d])([a-f\d])$/i;
    hex = hex.replace(shorthandRegex, function(m, r, g, b) {
        return r + r + g + g + b + b;
    });

    let result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
    return result ? {
        r: parseInt(result[1], 16),
        g: parseInt(result[2], 16),
        b: parseInt(result[3], 16)
    } : null;
}

function interpolateColor(color1, color2, factor) {
    if (arguments.length < 3) { 
        factor = 0.5; 
    }
    let result = color1.slice();
    for (let i = 0; i < 3; i++) {
        result[i] = Math.round(result[i] + factor * (color2[i] - result[i]));
    }
    return result;
}

function rgbToHex(rgb) {
    return "#" + ((1 << 24) + (rgb[0] << 16) + (rgb[1] << 8) + rgb[2]).toString(16).slice(1).toUpperCase();
}

function calculateGradient(startColor, middleColor, endColor, steps) {
    let startRGB = [startColor.r, startColor.g, startColor.b];
    let middleRGB = [middleColor.r, middleColor.g, middleColor.b];
    let endRGB = [endColor.r, endColor.g, endColor.b];
    
    let gradientColors = [];
    
    // First half of the gradient (from start to middle)
    for (let i = 0; i < steps / 2; i++) {
        let factor = i / (steps / 2);
        let interpolatedColor = interpolateColor(startRGB, middleRGB, factor);
        gradientColors.push(rgbToHex(interpolatedColor));
    }
    
    // Second half of the gradient (from middle to end)
    for (let i = 0; i < steps / 2; i++) {
        let factor = i / (steps / 2);
        let interpolatedColor = interpolateColor(middleRGB, endRGB, factor);
        gradientColors.push(rgbToHex(interpolatedColor));
    }
    
    return gradientColors;
}

let steps = total; // Number of steps in the gradient
let ColorRange = calculateGradient(startColor, middleColor, endColor, steps);
const ColorLevel = calculateGradient(startColor, middleColor, endColor, steps);

// Custom Mapbox Studio style, fetched as raster tiles via Mapbox's Static
// Tiles API (no extra dependency needed -- plain ol/source/XYZ). Needs
// REACT_APP_MAPBOX_TOKEN set (frontend/.env) to a Mapbox access token.
// 512px tiles (tileSize: 512 below) match Mapbox GL's own tile grid; ol
// adjusts its zoom/resolution mapping accordingly.
const MAPBOX_STYLE = "kauebraga/cmu471b2y000p01sag1l04rlv";
const MAPBOX_TOKEN = process.env.REACT_APP_MAPBOX_TOKEN;

const GetBaseLayer = () => {
	return new TileLayer({
		source: new XYZ({
			// No {r}/retina here -- that's a Leaflet URL-template convention,
			// not an OpenLayers one; ol/source/XYZ doesn't substitute it, so
			// it was being sent to Mapbox literally (producing 404s).
			url: `https://api.mapbox.com/styles/v1/${MAPBOX_STYLE}/tiles/512/{z}/{x}/{y}?access_token=${MAPBOX_TOKEN}`,
			tileSize: 512,
			attributions:
				'&copy; <a href="https://www.mapbox.com/about/maps/">Mapbox</a> &copy; ' +
				'<a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors',
			crossOrigin: "anonymous",
		}),
	});
};

const Strokes = {
	normalStroke: new Stroke({ color: "#707070",  width: 1 }),
	selectedStroke: new Stroke({ color: "#23BCED", width: 4})
}

const svgMarker = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" width="48" height="48">'
	+ '<path d="M15 3L15 5.0625C9.730469 5.539063 5.539063 9.734375 5.0625 15L3 15L3 17L5.0625 17C5.539063 22.265625 9.734375 26.460938 15 26.9375L15 29L17 29L17 26.9375C22.265625 26.460938 26.460938 22.265625 26.9375 17L29 17L29 15L26.9375 15C26.460938 9.734375 22.269531 5.539063 17 5.0625L17 3 Z M 15 7.03125L15 9L17 9L17 7.03125C21.191406 7.484375 24.480469 10.808594 24.9375 15L23 15L23 17L24.96875 17C24.515625 21.191406 21.191406 24.515625 17 24.96875L17 23L15 23L15 24.96875C10.808594 24.515625 7.484375 21.191406 7.03125 17L9 17L9 15L7.0625 15C7.519531 10.808594 10.808594 7.484375 15 7.03125 Z M 16 12C13.789063 12 12 13.789063 12 16C12 18.210938 13.789063 20 16 20C18.210938 20 20 18.210938 20 16C20 13.789063 18.210938 12 16 12Z" fill="#23bced" />'
	+ '</svg>'

const iconStyle = new Style({
	image: new Icon({
		offset: [0, 0],
		opacity: 1,
		scale: 1,
		src: 'data:image/svg+xml;utf8,' + encodeURIComponent(svgMarker)
	}),
	zindex: 20
});

const Styles = {
	cityStyle: new Style({
		image: new CircleStyle({
			radius: 10,
			fill: new Fill({ color: "white" }),
			stroke: new Stroke({
			color: "#707070",
			width: 1
			})
		})
	}), 
	selectedCity: new Style({
		fill: new Fill({ color: "white" }),
		stroke: new Stroke({
			color: "#707070",
			width: 2
		}),
		zindex: -1
	}),
	normal: new Style({
		image: new CircleStyle({
			radius: 10,
			fill: new Fill({ color: "white" }),
			stroke: new Stroke({ color: "#707070",  width: 1 })
		})
	}),
	selectStyle: new Style({
		image: new CircleStyle({
			radius: 11,
			fill: new Fill({color: "white"}),
			stroke: new Stroke({ color: "#23BCED", width: 4})
		}),
		zIndex: 100
	}),
	polygonStyle: new Style({
		fill: new Fill({ color: "rgba(0,0,0, 0.05)" }),
		stroke: new Stroke({
			color: "#fd630b",
			width: 2
		})      
	}),
	invisible: new Style({
		fill: new Fill({color: "transparent" }),
		stroke: new Stroke({color: "transparent", width: 0})
	}),
	neighborhood: new Style({
		fill: new Fill({color: "rgba(0,0,0,0.1)" }),
		stroke: new Stroke({color: "white", width: 2})
	}),
	emptyNeighborhood: new Style({
		fill: new Fill({color: "rgba(158,158,158,0.8)" }), // Grey, for missing scores
		stroke: new Stroke({color: "white", width: 2})
	}),
	selectedNeighborhood: new Style({
		fill: new Fill({color: "transparent" }),
		stroke: new Stroke({color: "#23BCED", width: 8}),
		zIndex: 200
	}),
	gridForLocationStep: new Style({
		fill: new Fill({color: "rgba(0,0,0,0.1)" }),
		stroke: new Stroke({color: "white", width: 1})
	}),
	selectedNeighborhoodForLocationStep: new Style({
		fill: new Fill({color: "rgba(0,0,0,0.2)" }),
		stroke: new Stroke({color: "#23BCED", width: 4}),
		zIndex: 200
	}),
};

const NoDataColor = "#9E9E9E"; // Grey

// Score is missing (null/undefined/"" or not a number) -- no value to color. 0 is a real score, colored on the scale.
const IsEmptyScore = (score) => {
	if (score === null || score === undefined || score === "") return true;
	return isNaN(Number(score));
}

const GetStyleForScore = (score, rangeValues) => {
	const style = new Style({
		//fill: new Fill({ color: ColorRange[Math.floor((score*total)/maxValue)]
		fill: new Fill({
			color: IsEmptyScore(score) ? NoDataColor : GetColorForScore(score, rangeValues)
		})
	})
	return style;
}

const GetCityCustomStyle = (fillColor, strokeWidth, strokeColor = "#707070") => {
	return new Style({
		image: new CircleStyle({
			radius: 10,
			fill: new Fill({ color: fillColor }),
			stroke: new Stroke({ color: strokeColor,  width: strokeWidth })
		})
	})
}

const GetColorForScore = (score, rangeValues) => {
	//let maxValue = rangeValues.max;
	//workaround when color variation values is less than total colors available
	const step = (rangeValues.max-rangeValues.min)/total;
	let color = (step === 0) ? 0 : Math.floor((score-rangeValues.min)/step)
	//console.log("Real color=", color)
	if (color>19) color = 19
	return ColorRange[color];
	//return ColorRange[Utils.DecimalAdjust("round", (score*total)/maxValue, -1)]
}

const GetStyleForSelectedNeighbohood = (score=0) => {
	const style = new Style({
		fill: new Fill({ color: 'transparent' }),
		stroke: new Stroke({
			color: "#707070",
			width: 6
		}),
	})
	return style;
};

// Load Indicators
const GetIndicators = () => {
	let livabilityIndicator = {};
	let mobilityIndicator = {};
	DataService.GetIndicators().then(e => {
		var data = e.data.sort((a, b) => {
			if (a.ign > b.ign) return -1;
			if (a.ign < b.ign) return 1;
			return 0;
		});
		livabilityIndicator = data.find(element => element.iid === "iid11");
		mobilityIndicator = data.find(element => element.iid === "iid5");
		let temp = orderIndicatorException(data, livabilityIndicator);
		temp = orderIndicatorException2(data, mobilityIndicator);
		return temp; 
	});
}

const orderIndicatorException = (array, element) => {
	let tempArray = array.filter((indicator) => indicator.iid !== "iid11");
	const lastLiveabilityIndex = tempArray.reduce((lastIdx, ind, idx) => ind.ign === element.ign ? idx : lastIdx, 0);
	tempArray.splice(lastLiveabilityIndex + 1, 0, element);
	return tempArray
}

const orderIndicatorException2 = (array, element) => {
	let tempArray = array.filter((indicator) => indicator.iid !== "iid5");
	const lastMobilityIndex = tempArray.reduce((lastIdx, ind, idx) => ind.ign === element.ign ? idx : lastIdx, 0);
	tempArray.splice(lastMobilityIndex + 1, 0, element);
	return tempArray
}

const TranslatedScoreForIndicator = (feature) => {
	let indicatorName;
	let selectElement = document.getElementById("indicator-select");
	var text= selectElement.options[selectElement.selectedIndex].text;
	indicatorName = text.replace(/[\s()]+|[^a-zA-Z0-9]/g, "");
	//indicatorName = indicatorName.charAt(0).toLowerCase() + indicatorName.slice(1) + "Score";
	//console.log("INDICATOR NAME: ",indicatorName)
	/*if (indicatorName === 'walkingCyclingScoreScore') indicatorName = 'walkabilityCyclabilityCombinedScore';
	else if (indicatorName === 'populationdensityScore') indicatorName = 'dwellingResidentialDensityScore';
	else if (indicatorName === 'streetConnectivityPermeabilityScore') indicatorName = 'streetConnectivityScore';
	else if (indicatorName === 'lifeQualityAssessmentScore') indicatorName = 'livabilityCombinedScore';
	else if (indicatorName === 'securitySecurityScore') indicatorName = 'safetyScore';
	else if (indicatorName === 'generalScoreScore') indicatorName = 'generalScore';	*/

	if (indicatorName === 'Retailqualitydiversity') indicatorName = 'retailFloorAreaRatioScore';
	else if (indicatorName === 'Intersectiondensity') indicatorName = 'streetConnectivityScore';
	else if (indicatorName === 'Populationdensity') indicatorName = 'dwellingResidentialDensityScore';
	else if (indicatorName === 'LandUseMix') indicatorName = 'landUseMixScore';
	else if (indicatorName === 'MobilityCombinedScore') indicatorName = 'walkabilityCyclabilityCombinedScore';
	else if (indicatorName === 'LivabilityCombinedScore') indicatorName = 'livabilityCombinedScore';
	else if (indicatorName === 'CrimedensitySecurity') indicatorName = 'safetyScore';
	//else if (indicatorName === 'TrafficSafety') indicatorName = 'trafficSafetyScore';
	else if (indicatorName === 'Accessibilitytohealthsportleisureandeducationandservicefacilities') 
		indicatorName = 'servicesScore';
	//else if (indicatorName === 'Greenspaceareaandnaturalenvironment') indicatorName = "naturalAreaScore";
	else if (indicatorName === 'ConcentrationsofparticulatematterPM25andNO2nitrogendioxide')
		indicatorName = 'environmentScore';
	else if (indicatorName === 'Totalscore') indicatorName = 'generalScore';

	// if (iid === 'iid1') indicatorName = 'retailFloorAreaRatioScore';
	// else if (iid === 'iid2') indicatorName = 'streetConnectivityScore';
	// else if (iid === 'iid3') indicatorName = 'dwellingResidentialDensityScore';
	// else if (iid === 'iid4') indicatorName = 'landUseMixScore';
	// else if (iid === 'iid5') indicatorName = 'walkabilityCyclabilityCombinedScore';
	// else if (iid === 'iid11') indicatorName = 'livabilityCombinedScore';
	// else if (iid === 'iid6') indicatorName = 'safetyScore';
	// else if (iid=== 'iid7') indicatorName = 'trafficSafetyScore';
	// else if (iid === 'iid8') iid = 'servicesScore';
	// else if (iid === 'iid9') indicatorName = "naturalAreaScore";
	// else if (iid === 'iid10') iid = 'environmentScore';
	// else if (iid === 'iid12') indicatorName = 'generalScore';

	//Return feature Score for current chosen Indicator
	return feature.getProperties().scores[indicatorName];
}

const LoadMapCities = (map) => {
	var vectorSource = new VectorSource({
		format: new GeoJSON(),
		features: GetCities(map),
		//loader: vectorLoader,
		projection: "EPSG:4326"
	});      

	var vectorLayer = new VectorLayer({
		source: vectorSource,
		style: MapUtils.Styles.normal,
		maxZoom: 8
	});
				
	map.addLayer(vectorLayer);      
	map.getView().fit(vectorSource.getExtent());

	map.getView().animate({
		zoom: map.getView().getZoom() - 0.1,
		duration: 300
	})
}

// Cities are loaded asynchronously (DataService.GetCities() in App.tsx)
// into localStorage.cities; on a fresh session there's a window before that
// resolves where it's genuinely unset (not the string "undefined" -- plain
// JS undefined, which JSON.parse throws on: "undefined" is not valid JSON).
// Every reader below goes through this instead of parsing localStorage.cities
// directly, so an early/fresh call just sees an empty list rather than crashing.
function GetStoredCities() {
	if (!localStorage.cities) return [];
	try {
		return JSON.parse(localStorage.cities) || [];
	} catch (e) {
		return [];
	}
}

const GetCities = (map) => {
	var res = {};
	res.data = [];
	res.data[0] = MapData(GetStoredCities());
	var features = new GeoJSON().readFeatures(res.data[0],
		{featureProjection: map.getView().getProjection()}
	);
	return features;
}

function CityData(id) {
	let cities = GetStoredCities();
	let filteredCity = cities.filter(city => city.cityId === id)
	if (filteredCity.length === 0) return;
	//console.log("Filtered City=", filteredCity)
	const cityFeature = new Feature({
		geometry: new Point([filteredCity[0].cityGeom.x, filteredCity[0].cityGeom.y])
	});
	return cityFeature;
}

function getCityIdByName(name) {
  let city = GetStoredCities().find(c => c.originalCityName === name);
  return city ? city.cityId : ""
}

const SetScores = (score) => {
	return ({
	    /*retailFloorAreaRatioScore: score.iid1,
		landUseMixScore: score.iid2,
		streetConnectivityScore: score.iid3,
		dwellingResidentialDensityScore: score.iid4,	
		walkabilityCyclabilityCombinedScore: score.iid5,
		servicesScore: score.iid6,
		environmentScore: score.iid7,
		safetyScore: score.iid8,
		livabilityCombinedScore: score.iid9,
		generalScore: score.iid10
		
		
		*/
		iid1: score.iid1,
		iid2: score.iid2,
		iid3: score.iid3,
		iid4: score.iid4,
		iid5: score.iid5,
		iid6: score.iid6,
		iid7: score.iid7,
		iid8: score.iid8,
		iid9: score.iid9,
		iid10: score.iid10,
		iid11: score.iid11,
		iid12: score.iid12,
		iid13: score.highestRetailRloorArea,
		iid14: score.highestStreetConnectivity,
		iid15: score.highestPopulationDensity,
		iid16: score.highestLandUseMix,
		iid17: score.highestWalkabilityCyclabilityCombined,
		iid18: score.highestTrafficSafety,
		iid19: score.highestAccessibility,
		iid20: score.highestNaturalArea,
		iid21: score.highestExposurePollutant,
		iid22: score.highestLivabilityCombined,
		
	})
}

function MapData(cities) {
	if (cities === undefined) return;
	
	const features = [];
	cities.forEach(city => {
		features.push(
		{
			type: "Feature",
			id: city.cityId,
			geometry: { 
				type: "Point", 
				coordinates: [city.geom.x, city.geom.y]
			},
				properties: {
					score: "",
					cityId: city.cityId,
					city: city.originalCityName,
					name: city.originalCityName,
					country: city.countryName,
					scores: SetScores(city)				
			}
		})
	});

	var json = { type: "FeatureCollection", features: features};

	//Set Cities in Storage in JSON Format
	//console.log('Cities=', json.features);
	localStorage.setItem("cityFeatures", JSON.stringify(json));
	return json;
}

const sortCitiesByName = (features) => {
	let sorted = features.sort(function(a, b) {
	if (a.values_.city < b.values_.city)
		return -1;
	});		
	return sorted;
}

const sortCitiesByOriginalCityName = (features) => {
	let sorted = features.sort(function(a, b) {
	if (a.originalCityName < b.originalCityName)
		return -1;
	});
	return sorted;
}

// Sorts by country first, then by city name within each country.
// Required order for MUI Autocomplete's groupBy (by countryName) to work,
// since it only groups consecutive options sharing the same group value.
const sortCitiesByCountryThenName = (features) => {
	let sorted = features.sort(function(a, b) {
		const countryA = a.countryName || "";
		const countryB = b.countryName || "";
		if (countryA !== countryB)
			return countryA.localeCompare(countryB);
		return (a.originalCityName || "").localeCompare(b.originalCityName || "");
	});
	return sorted;
}

// Highest possible score of each Maps indicator (same scales as utils/indicatorMap.js and the DB score columns)
const IndicatorMaxScores = { iid1: 25, iid2: 25, iid3: 25, iid4: 25, iid5: 100, iid8: 70, iid9: 10, iid10: 10, iid11: 100, iid12: 10000 };

// Score of a city/neighbourhood feature as a number, or null when it has none
const featureScore = (feature) => {
	const score = feature.values_.score;
	if (score === null || score === undefined || score === "" || isNaN(Number(score))) return null;
	return Number(score);
}

const featureName = (feature) => String(feature.values_.name || feature.values_.city || "");

// Highest score first; equal scores by name, so the order is always the same; no score last
const sortFeaturesByScore = (features) => {
	return features.sort(function(a, b) {
		const scoreA = featureScore(a), scoreB = featureScore(b);
		if (scoreA !== scoreB) {
			if (scoreA === null) return 1;
			if (scoreB === null) return -1;
			return scoreB - scoreA;
		}
		return featureName(a).localeCompare(featureName(b));
	});
}

// Rank of each feature of a list sorted by sortFeaturesByScore. Equal scores share the rank of
// the first of them ("1, 2, 2, 4"): rank = 1 + number of features with a higher score.
const getRanks = (sortedFeatures) => {
	let ranks = [];
	sortedFeatures.forEach((feature, i) => {
		ranks.push(i > 0 && featureScore(feature) === featureScore(sortedFeatures[i - 1]) ? ranks[i - 1] : i + 1);
	});
	return ranks;
}

// Position of one feature: its rank, the positions shared with the features tied with it, and the total
const getRankInfo = (sortedFeatures, id) => {
	const index = sortedFeatures.findIndex(feature => feature.id_ === id);
	if (index === -1 || id === "" || id === undefined) return null;
	const score = featureScore(sortedFeatures[index]);
	let first = index, last = index;
	while (first > 0 && featureScore(sortedFeatures[first - 1]) === score) first--;
	while (last < sortedFeatures.length - 1 && featureScore(sortedFeatures[last + 1]) === score) last++;
	return { index, first, last, rank: first + 1, lastRank: last + 1, tied: last - first, total: sortedFeatures.length, score };
}

// Data for the RankChart: every feature, highest to lowest, and where the selected one is
const getRankChartData = (sortedFeatures, selectedId, getColor) => ({
	items: sortedFeatures.map(feature => ({ label: featureName(feature), score: featureScore(feature), color: getColor(feature) })),
	ranks: getRanks(sortedFeatures),
	selected: getRankInfo(sortedFeatures, selectedId)
});

// Highest and lowest score of the features; missing scores are left out (they used to count as 0)
function GetMaxMin(array, propName) {
	let maxValue = -Infinity, minValue = Infinity;
	array.forEach(feature => {
		const value = feature.values_[propName];
		if (IsEmptyScore(value)) return;
		maxValue = Math.max(maxValue, Number(value));
		minValue = Math.min(minValue, Number(value));
	});
	return maxValue === -Infinity ? {max: 0, min: 0} : {max: maxValue, min: minValue};
}

const getFeaturePolygon = (coordinates) => {
	//console.log("coordinates: ", coordinates)
	var convertedCoordinates = [];
	coordinates.forEach(element => {
		convertedCoordinates.push([element.x, element.y])
	});

	const polygonFeature = new Feature({
			type: "Polygon",          
			geometry: new Polygon( [convertedCoordinates]).transform('EPSG:4326','EPSG:3857')
	});

	polygonFeature.setStyle(Styles.polygonStyle);
	return polygonFeature;
}

const getFeaturePolygonForLocation = (coordinates) => {
	var convertedCoordinates = [];
	coordinates.forEach(element => {
		convertedCoordinates.push([element.x, element.y])
	});

	const polygonFeature = new Feature({
		type: "Polygon",          
		geometry: new Polygon( [convertedCoordinates]).transform('EPSG:4326','EPSG:3857')
	});

	const style = new Style({
  		fill: new Fill({ color: 'rgba(0,0,0,0.05)' }),
  		stroke: new Stroke({ color: '#ffffff', width: 5 })
	});

	polygonFeature.setStyle(style);
	return polygonFeature;
}

/*function vectorLoader() {
	console.log("Cities=", localStorage.cities.length)
	var res = {};
	res.data = [];
	res.data[0] = mapData(JSON.parse(localStorage.cities));      

	var geoJsonFormat = new GeoJSON();
	var features = geoJsonFormat.readFeatures(res.data[0], {
		featureProjection: map.getView().getProjection()
	});
	vectorSource.addFeatures(features);
}*/

const LoadTooltipOverlay = (map) => {
    //Overlay
    const container = document.getElementById('popup');
    const content = document.getElementById('popup-content');

    /* Create an overlay to anchor the popup to the map. */
    const overlay = new Overlay({
		element: container,
		/*autoPan: { animation: { duration: 250,}, },*/
    });

    map.on('pointermove', function(evt) {
		evt.preventDefault();
			
		var feature_onHover;
      	feature_onHover = map.forEachFeatureAtPixel(evt.pixel, function(feature, layer) {
			//console.log("Feature=", feature);
			return feature;
		});

		if (feature_onHover) {				
        	const coordinate = evt.coordinate;			
			if (feature_onHover.values_.type === 'Polygon') {
				content.innerHTML = '<span>'+feature_onHover.getProperties().name+"</span>";
				//if (feature_onHover.values_.score != "") 
				//	content.innerHTML += "<br/><span>Score: "+feature_onHover.values_.score+"</span>"
			} else
				content.innerHTML = '<span>'+feature_onHover.values_.city+",<br/>"+feature_onHover.values_.country+"</span>";
				overlay.setPosition(coordinate);
				container.style.display = 'block';
				map.addOverlay(overlay);
      	} else {
			container.style.display = 'none';
      	}
    });
}

const LoadTooltipOverlayForNeighbourhood = (map) => {
    //Overlay
    const container = document.getElementById('popup');
    const content = document.getElementById('popup-content');
	if(container === null || container === undefined) return;
    /* Create an overlay to anchor the popup to the map. */
    const overlay = new Overlay({
		element: container,
    });

    map.on('pointermove', function(evt) {
		evt.preventDefault();
			
		var feature_onHover;
      	feature_onHover = map.forEachFeatureAtPixel(evt.pixel, function(feature, layer) {
			return feature;
		});

		// pointer cursor over city dots, so they read as clickable
		map.getTargetElement().style.cursor = feature_onHover && feature_onHover.values_.type !== 'Polygon' ? 'pointer' : '';
		// near the right edge, open the tooltip to the left so it isn't cut off by the map
		container.classList.toggle('flip-left', evt.pixel[0] > map.getSize()[0] - 160);

		if (feature_onHover) {
        	const coordinate = evt.coordinate;
			//console.log("feature_onHover id =", feature_onHover.id_);
			try {
				if (feature_onHover.values_.type !== 'Polygon' && feature_onHover.values_.city) {
					// city dot: name, with the country underneath (styled by .popup-country)
					content.innerHTML = '<span class="popup-city">' + feature_onHover.values_.city + '</span>'
						+ '<span class="popup-country">' + (feature_onHover.values_.country || '') + '</span>';
					overlay.setPosition(coordinate);
					container.style.display = 'block';
					map.addOverlay(overlay);
				} else if (feature_onHover.values_.type === 'Polygon' && feature_onHover.id_.indexOf("Grid")>0 ) {
					if (feature_onHover.id_ !== localStorage.getItem("grid_onHoner_id")) {					
						//localStorage.setItem("grid_onHoner_id", feature_onHover.id_);
						content.innerHTML = '<span>'+feature_onHover.getProperties().name + "<br/> #" + feature_onHover.id_.split("-")[1] +"</span>";
						overlay.setPosition(coordinate);
						container.style.display = 'block';
						map.addOverlay(overlay);
					}
				} else {
					container.style.display = 'none';   // e.g. the city outline: no tooltip, and don't leave the last one up
				}
			} catch (error) {
				console.error("Error in tooltip overlay: ", error);
			}
			/* else
				content.innerHTML = '<span>'+feature_onHover.values_.city+",<br/>"+feature_onHover.values_.country+"</span>";
			*/
      	} else {
			container.style.display = 'none';
      	}
    });
}


const convertFeaturesToCSV = (features, indicators) => {
	// Ordenar alfabeticamente pelo campo 'name'
	const sorted = features.sort((a, b) => {
		const nameA = a.get('name')?.toLowerCase() || "";
		const nameB = b.get('name')?.toLowerCase() || "";
		return nameA.localeCompare(nameB);
	});

	//console.log("indicators=", indicators);	
	const scoreKeys = Object.keys(features[0].get('scores') || {});
	const headers = ["name", "id", ...scoreKeys];

	// Translate Indicator Ids to real names
	const translatedHeader = headers.map(iid =>
		indicators.find(item => item.iid === iid)?.in || iid
	);

	const rows = features.map(f => {
		const name = f.get('name') || "";
		const id = f.getId() || f.get('id') || "";
		const scores = f.get('scores') || {};

		return [
			name,
			id,
			...scoreKeys.map(key => scores[key] ?? "")
		].map(val => `"${val}"`).join(",");
	});

	return [translatedHeader.join(","), ...rows].join("\n");
};

const MapUtils = {
	ColorLevel, ColorRange, Styles, Strokes, SetScores, ColorScale, GetColorForScore, GetStyleForScore, IsEmptyScore, GetCityCustomStyle, GetBaseLayer,
	GetCities, GetStoredCities, MapData, LoadMapCities, CityData, getCityIdByName, GetIndicators, TranslatedScoreForIndicator, LoadTooltipOverlay, LoadTooltipOverlayForNeighbourhood,
	getFeaturePolygon, getFeaturePolygonForLocation, GetStyleForSelectedNeighbohood, sortCitiesByName, sortCitiesByOriginalCityName, sortCitiesByCountryThenName, sortFeaturesByScore, getRanks, getRankInfo, getRankChartData, IndicatorMaxScores,
	GetMaxMin, convertFeaturesToCSV
}
  
export default MapUtils;